import { render, staticRenderFns } from "./TasksOverview.view.vue?vue&type=template&id=901d39ce&scoped=true&"
import script from "./TasksOverview.view.vue?vue&type=script&lang=js&"
export * from "./TasksOverview.view.vue?vue&type=script&lang=js&"
import style0 from "./TasksOverview.view.vue?vue&type=style&index=0&id=901d39ce&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901d39ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VFadeTransition,VIcon})
